/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantComplianceSummaryWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("TenantComplianceSummaryWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return TenantComplianceSummaryWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<TenantComplianceSummaryWidgetConfiguration>): TenantComplianceSummaryWidgetConfiguration {
        let obj = Object.assign(new TenantComplianceSummaryWidgetConfiguration(), model);
        TenantComplianceSummaryWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantComplianceSummaryWidgetConfiguration>): TenantComplianceSummaryWidgetConfiguration {
        if (!model) return null;
        return TenantComplianceSummaryWidgetConfiguration.newInstance(<TenantComplianceSummaryWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantComplianceSummaryWidgetConfiguration) {
        if (!obj) return;

        models.TenantComplianceSummaryWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantComplianceSummaryWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TenantComplianceSummaryWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
